export const Permissions = {
  users: {
    create: "users:create",
    read: "users:read",
    update: "users:update",
    delete: "users:delete",
    ban: "users:ban",
  },
  audit: {
    read: "audit:read",
  },
  products: {
    read: "products:read",
    write: "products:write",
  },
  orders: {
    read: "orders:read",
    write: "orders:write",
  },
  snippets: {
    read: "snippets:read",
    write: "snippets:write",
  },
  settings: {
    write: "settings:write",
  },
  reports: {
    read: "reports:read",
  },
  expenses: {
    read: "expenses:read",
    write: "expenses:write",
  },
  inventory: {
    read: "inventory:read",
    write: "inventory:write",
  },
  importOrders: {
    read: "import_orders:read",
    write: "import_orders:write",
    receive: "import_orders:receive",
    cancel: "import_orders:cancel",
  },
  customJobs: {
    read: "custom_jobs:read",
    write: "custom_jobs:write",
  },
  restockWaitlist: {
    read: "restock_waitlist:read",
    write: "restock_waitlist:write",
  },
  eventSales: {
    read: "event_sales:read",
    write: "event_sales:write",
  },
} as const;

export const ALL_PERMISSIONS = Object.entries(Permissions).flatMap(
  ([resource, actions]) =>
    Object.entries(actions).map(([action, id]) => ({ id, resource, action })),
);

export type PermissionId = (typeof ALL_PERMISSIONS)[number]["id"];

// Human-friendly labels for rendering in UI
export const RESOURCE_LABELS: Record<string, string> = {
  users: "ຜູ້ໃຊ້",
  audit: "ບັນທຶກການກວດກາ",
  products: "ສິນຄ້າ",
  orders: "ອໍເດີ້",
  snippets: "ຂໍ້ຄວາມແຊດ",
  settings: "ການຕັ້ງຄ່າຮ້ານ",
  reports: "ລາຍງານ",
  expenses: "ລາຍຈ່າຍ",
  inventory: "ຮັບເຂົ້າສະຕັອກ",
  importOrders: "ສັ່ງນຳເຂົ້າ",
  customJobs: "ງານສັ່ງເຮັດ",
  restockWaitlist: "ລາຍການລໍຖ້າສິນຄ້າ",
  eventSales: "ອອກງານ",
};

export const ACTION_LABELS: Record<string, string> = {
  create: "ສ້າງ",
  read: "ເບິ່ງ",
  update: "ແກ້ໄຂ",
  delete: "ລຶບ",
  ban: "ລະງັບ",
  write: "ຈັດການ",
  receive: "ຮັບເຂົ້າ",
  cancel: "ຍົກເລີກ",
  all: "ທັງໝົດ",
};

export function getResourceLabel(resource: string): string {
  return RESOURCE_LABELS[resource] ?? resource;
}

export function getActionLabel(action: string): string {
  return ACTION_LABELS[action] ?? action;
}

export function getPermissionLabel(id: PermissionId): string {
  const [resource, action] = (id as string).split(":");
  return `${getActionLabel(action ?? "")} ${getResourceLabel(resource ?? "")}`;
}

export function getPermissionLabels(ids: PermissionId[]): string[] {
  return ids.map((id) => getPermissionLabel(id));
}
